import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkStudyLessonTeacherIsLanguage',
})
export class CheckStudyLessonTeacherIsLanguagePipe implements PipeTransform {
  transform(currentLesson: any, ...args: any[]): any {
    const lessons = args[0];
    if (!currentLesson) {
      return false;
    }
    switch (currentLesson) {
      case -1:
        return false;
        break;
      case -2:
        return true;
        break;
      case -3:
        return false;
        break;

      default:
        const founded = lessons.find(
          (lesson: any) => lesson.id == currentLesson
        );
        if (founded.type == 'language') {
          return true;
        } else {
          return false;
        }

        break;
    }
  }
}
